import {Injectable} from '@angular/core';
import {catchError} from 'rxjs/operators';
import {Observable, throwError} from 'rxjs';
import {HttpService} from '../http.service';
import {AppSettingsService} from '../app-settings.service';

@Injectable({
  providedIn: 'root'
})
export class LpNotificationsService {
  readonly baseUrl = this.appSettingsService.localEnv ? 'https://localhost:7018/api/v2/lp/notifications/' : 'v2/lp/notifications/';

  constructor(private http: HttpService, private appSettingsService: AppSettingsService) { }

  getNotifications(): Observable<{needAttentionBanksNotification: {numOfBanksNeedAttention: number}, pendingPaymentRequestsNotification: {id: number, companyName: string, holdingDiscriminator: string}[]}> {
    return this.http.getTyped<{needAttentionBanksNotification: {numOfBanksNeedAttention: number}, pendingPaymentRequestsNotification: {id: number, companyName: string, holdingDiscriminator: string}[]}>(this.baseUrl).pipe(
      catchError(err => {
        return throwError(err);
      })
    );
  }
}
